import { render, staticRenderFns } from "./RevenueMenu.vue?vue&type=template&id=fd98d5ee&scoped=true"
import script from "./RevenueMenu.vue?vue&type=script&lang=js"
export * from "./RevenueMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd98d5ee",
  null
  
)

export default component.exports